import { motion } from 'framer-motion';
import React from 'react';

const Loader = () => {

  return (
    <>
      <motion.div
        className="flex items-center justify-center fixed right-full top-0 bottom-0 w-screen h-screen z-30 bg-black"
        initial={{ x: "100%", width: "100%" }}
        animate={{ x: "0%", width: "0%" }}
        exit={{ x: ["0%", "100%"], width: ["0%", "100%"] }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <motion.div 
        className='overflow-hidden capitalize flex flex-col items-center justify-center space-y-5'
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          <h1 className='text-white text-xl mobile:text-3xl tablet:text-5xl desktop:text-7xl'>
             <span className='inline-block'>athena mercury</span> 
          </h1>
          <hr className='mx-auto bg-black h-px w-3/4 my-7'/>
          <h3 className='text-white text-sm mobile:text-lg tablet:text-2xl desktop:text-4xl'>
             <span className='inline-block'>new age couture</span>  
          </h3>
        </motion.div>
    </motion.div>
      <motion.div
        className="fixed right-full top-0 bottom-0 w-screen h-screen z-20 bg-white"
        initial={{ x: "100%", width: "100%" }}
        animate={{ x: "0%", width: "0%" }}
        transition={{ delay: 0.2, duration: 1, ease: "easeInOut" }}
      />
      <motion.div
        className="fixed right-full top-0 bottom-0 w-screen h-screen z-10 bg-black"
        initial={{ x: "100%", width: "100%" }}
        animate={{ x: "0%", width: "0%" }}
        transition={{ delay: 0.4, duration: 1, ease: "easeInOut" }}
      />
    </>
  );
};

export default Loader;
